const prevButton = `
<div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide">
</div>`

const nextButton = `
<div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide">
</div>`
export default function () {

  const widgetName = 'swiperWidgetMainFeature';
  const widgetOpts = swiperWidgetMainFeatureOpts;
  let autoplay = {
    delay: 6000,
  }

  const swiperContainers = `
    <div class="swiper-container">
      <div class="swiper-wrapper">
      </div>
    </div>`;

  // Slide Template
  function buildSlideTemplate(slide) {

    let locationTrue = ""

    if (slide.DetailLinkText === "More" || slide.DetailLinkText === "") {
      locationTrue = `<span class="feature-description" style="display: none;">${slide.DetailLinkText}</span> `
    } else {
      locationTrue = `<span class="feature-description">${slide.DetailLinkText}</span> `
    }

const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <a class="mobile-arrow" href="#first-content"></a>
            <div class="pagination-container">
            ${locationTrue}    
                <div class="navigation-container">
                ${prevButton}
                    <div class="swiper-pagination"></div>
                ${nextButton}
                </div>
            </div>
        <div class="swiper-lazy-preloader"></div>
        </div>
        <div class="main-events-text">
          <h4 class="feature-title">${slide.Title}</h4>
          <span class="feature-description">${slide.Description}</span>    
        </div>
      </div>`;
      return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    function autoPlayCondition() {
      if (widgetData.length > 1) {
        return autoplay
      } else {
        autoplay = false
        return autoplay
      }
    }

    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
    widgetData.forEach(function (slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: autoPlayCondition(),
      spaceBetween: 0,
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: false,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    });
  }

  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      // console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
